import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M16 22h2a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v3",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Polyline, { points: "14 2 14 8 20 8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4.04 11.71a5.84 5.84 0 1 0 8.2 8.29", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M13.83 16A5.83 5.83 0 0 0 8 10.17V16h5.83Z",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "FilePieChart";
const FilePieChart = memo(themed(Icon));
export {
  FilePieChart
};
//# sourceMappingURL=file-pie-chart.js.map
